<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@8" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon icon="user" class="mr-2" :strokewidth="3" fill="white" />
          <v-toolbar-title class="ml-1">
            Korisnik
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Info</v-tab>
              <v-tab>Restrikcije</v-tab>
              <v-tab>Avatar</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-tabs-items v-model="active_tab">
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <form>
                          <v-text-field
                            class="mb-1"
                            v-model="user.username"
                            outlined
                            :disabled="user.id === 0 ? false : true"
                            counter
                            maxlength="255"
                            label="Korisničko ime"
                            autocomplete="username"
                          ></v-text-field>
                          <v-text-field
                            v-model="user.password"
                            outlined
                            type="password"
                            counter
                            maxlength="255"
                            label="Lozinka"
                            autocomplete="new-password"
                          ></v-text-field>
                        </form>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                        <v-text-field
                          v-model="user.name"
                          outlined
                          counter
                          maxlength="255"
                          label="Ime i prezime korisnika"
                          required
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-6 pt-1 pb-1">
                        <webpage_accounts_lookup
                          :selected_id="user.account_id"
                          update="wp_user_account_changed"
                        ></webpage_accounts_lookup>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                        <v-text-field
                          v-model="user.email"
                          outlined
                          label="Email adresa"
                          counter
                          maxlength="255"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                        <v-text-field
                          v-model="user.telephone"
                          outlined
                          label="Telefon"
                          counter
                          maxlength="255"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-switch
                        hide-details
                        v-model="user.active"
                        label="Aktivan"
                      ></v-switch>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content v-if="user.id == 0">
                        <v-dialog
                          ref="valid_from"
                          v-model="show_active_date"
                          :return-value.sync="user.active_date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="active_date_formatted"
                              label="Datum aktivacije"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                              :width="80"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="user.active_date"
                            @change="save_active_date"
                            locale="bs-bs"
                            :first-day-of-week="1"
                            :show-week="true"
                          >
                          </v-date-picker>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item class="text-wrap">
                      <v-list-item-content
                        style="display: grid; grid-template-columns: max-content 1fr;align-items: center; vertical-align:middle;"
                      >
                        <img
                          v-if="user.image_user !== null"
                          :style="get_image_background(user.image_user)"
                        />
                        <div v-else>&nbsp;</div>

                        <v-file-input
                          v-model="file_image_user"
                          accept="image/png, image/jpeg, image/bmp"
                          :rules="rules_image_user"
                          outlined
                          persistent-hint
                          hint="Odaberite korisničku sliku. Max veličina slike je 2MB."
                          label="Korisnička slika"
                          prepend-inner-icon="mdi-paperclip"
                          @click:clear="clearFileInput()"
                        >
                          <template v-slot:prepend-inner>
                            <sabira_icon icon="image" class="mr-2" />
                          </template>
                        </v-file-input>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="is_btn_loading" text @click="save_user()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_accounts_lookup: () => import("@/components/lookups/accounts"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    rules_image_user: [
      (value) => !value || value.size < 2000000 || "Max veličina slike je 2MB.",
    ],
    is_loading: false,
    is_btn_loading: false,
    active_tab: 0,
    show_active_date: null,
    file_image_user: null,
    user: {
      name: null,
      acc_name: null,
      address: null,
      email_address: null,
      telephone: null,
      id_number: 0,
      vat_number: null,
      valuta: 0,
      credit_limit: 0,
      image_user: null,
    },
    title: "Kreiranje profila novog korisnika",
    visible: false,
  }),
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  computed: {
    active_date_formatted() {
      return this.user.active_date
        ? this.$moment(new Date(this.user.active_date)).format("DD MMMM YYYY")
        : null;
    },
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
  watch: {
    file_image_user: {
      handler() {
        if (this.file_image_user !== null) {
          this.convert_to_base64(this.file_image_user).then((resp) => {
            this.user.image_user = resp;
          });
        }
      },
    },
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_user();
        } else {
          this.user = {
            id: 0,
            name: null,
            acc_name: null,
            address: null,
            email_address: null,
            telephone: null,
            id_number: null,
            vat_number: null,
            valuta: 0,
            credit_limit: 0,
            country: null,
            city: null,
            active: true,
            image_user: null,
            active_date: null,
            deactive_date: null,
          };
        }
      },
      immediate: false,
    },
  },
  methods: {
    clearFileInput() {
      this.file_image_user = null;
      this.user.image_user = null;
    },
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.user.username == null || this.user.username.length == 0) {
          has_errors = true;
          reject("Username polje je obavezno.");
        }
        if (this.user.password == null || this.user.password.length == 0) {
          has_errors = true;
          reject("Lozinka polje je obavezno.");
        }
        if (this.user.name == null || this.user.name.length == 0) {
          has_errors = true;
          reject("Ime i prezime korisnika polje je obavezno.");
        }
        if (this.user.account_id == null || this.user.account_id.length == 0) {
          has_errors = true;
          reject("Firma polje je obavezno.");
        }
        if (this.user.email == null || this.user.email.length == 0) {
          has_errors = true;
          reject("Email adresa polje je obavezno.");
        }
        if (this.user.telephone == null || this.user.telephone.length == 0) {
          has_errors = true;
          reject("Telefon polje je obavezno.");
        }
        if (
          this.user.active_date == null ||
          this.user.active_date.length == 0
        ) {
          has_errors = true;
          reject("Datum polje je obavezno.");
        }
        if (
          this.file_image_user !== null &&
          this.file_image_user.size > 2000000
        ) {
          this.file_image_user = null;
          this.user.image_user = null;
          has_errors = true;
          reject("Max veličina slike je 2MB.");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    get_image_background(image) {
      return (
        "width: 100px;height:100px;background-image: url('" +
        image +
        "');background-size: contain;background-position:center;"
      );
    },
    convert_to_base64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        let rawImg;
        reader.onloadend = () => {
          rawImg = reader.result;
          resolve(rawImg);
        };
        reader.readAsDataURL(file);
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_user_account_changed", (account) => {
        if (account !== null) {
          this.user.acc_name = account.name;
          this.user.account_id = account.id;
        }
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_user_account_changed");
    },
    save_active_date() {
      this.$refs.valid_from.save(this.user.active_date);
    },
    close_dialog() {
      this.$webpageEventBus.$emit("close_user");
    },
    get_user() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/users/get_user",
        data: {
          id: this.id,
        },
      })
        .then((resp) => {
          let r_user = resp.data.result;
          this.user.id = r_user.id;
          this.user.account_id = r_user.account_id;
          this.user.name = r_user.name;
          this.user.username = r_user.username;
          this.user.email = r_user.email;
          this.user.telephone = r_user.telephone;
          this.user.active = r_user.active;
          this.user.password = null;
          this.user.image_user = r_user.image_user;
          this.user.active_date = this.$moment(new Date(r_user.active_date))
            .local()
            .format("YYYY-MM-DD HH:SS");
          this.user.deactive_date = this.$moment(new Date(r_user.deactive_date))
            .local()
            .format("YYYY-MM-DD HH:SS");
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e.message,
            timeout: 4000,
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    save_user() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.user.active_date = this.$moment(new Date(this.user.active_date))
            .local()
            .format("YYYY-MM-DD HH:SS");
          if (this.user.active == false) {
            this.user.deactive_date = this.$moment(new Date())
              .local()
              .format("YYYY-MM-DD");
          } else {
            this.user.deactive_date = null;
          }

          this.$http({
            method: "POST",
            url: "/users/update",
            data: this.user,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Profil korisnika je ažuriran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_user");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
};
</script>

<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}
</style>
